import { useContext, useEffect, useRef, useState } from 'react'

import { EditContext } from 'Components/Hooks/ContextEdit'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import ComplexDialog from 'Components/UI/Molecules/ComplexDialog'
import ComplexDialogActions from 'Components/UI/Molecules/ComplexDialog/Actions'
import ComplexDialogHistory from 'Components/UI/Molecules/ComplexDialogHistory'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import { interfaces } from 'service/interfaces'

import { FieldsQualities } from './fields'
import Files from './Files'
import HomeContent from './Home'

const DialogEdit = (props) => {
  const {
    open,
    handleClose,
    optionsWafers,
    productGroup,
    optionsProducts,
    changeRender,
    products,
    setData,
    familys,
  } = props

  const [edit, setEdit] = useContext(EditContext)

  const initialProductRef = useRef(null)

  const sanitizeBodyForUpdate = (product) => {
    if (!product) return {}
    const {
      fotos: _fotos,
      historial: _historial,
      usuario: _usuario,
      fecha_creacion: _fecha_creacion,
      canEdit: _canEdit,
      ...rest
    } = product

    if (rest.orden_colocado === '') {
      rest.orden_colocado = null
    }

    return rest
  }

  useEffect(() => {
    if (!open) return

    if (initialProductRef.current?.id === optionsProducts?.id) return

    initialProductRef.current = JSON.parse(JSON.stringify(optionsProducts))
  }, [open, optionsProducts])

  const handleChange = (productId, name, value) => {
    setData((prev) => ({
      ...prev,
      products: prev.products.map((product) => {
        if (product.id !== productId) return product

        // name = "calidad[0].excelente_detalle"
        const [arrayField, rest] = name.split('[')
        const index = Number(rest.split(']')[0])
        const field = rest.split('.')[1]

        const updatedArray = [...product[arrayField]]
        updatedArray[index] = {
          ...updatedArray[index],
          [field]: value,
        }

        return {
          ...product,
          [arrayField]: updatedArray,
        }
      }),
    }))
  }

  const createDismissableSnackbar = useCustomSnackbar()
  const [loading, setLoading] = useState()

  const horizontalTabs = [
    {
      id: 0,
      title: 'Inicio',
      color: 'primary',
    },
    {
      id: 1,
      title: 'Calidades',
      color: 'primary',
    },
    {
      id: 2,
      title: 'Fotografías',
      color: 'primary',
    },
    {
      id: 3,
      title: 'Historial',
      color: 'primary',
    },
  ]

  const setImg = (newFotos, productId) => {
    setData((prev) => ({
      ...prev,
      products: prev.products.map((product) =>
        product.id === productId ? { ...product, fotos: newFotos } : product
      ),
    }))
  }

  function handleCloseDialog() {
    if (initialProductRef.current && optionsProducts) {
      setData((prev) => ({
        ...prev,
        products: prev.products.map((product) =>
          product.id === optionsProducts.id
            ? JSON.parse(JSON.stringify(initialProductRef.current))
            : product
        ),
      }))
    }
    setEdit(false)
    handleClose()
  }

  const renderTabs = (index) => {
    switch (index) {
      case 0:
        return (
          <HomeContent
            data={optionsProducts}
            setData={setData}
            edit={edit}
            optionsWafers={optionsWafers}
            productGroup={productGroup}
            products={products}
            familys={familys}
            loading={loading}
          />
        )
      case 1:
        return (
          <div style={{ margin: '20px' }}>
            <InputsWithoutValidate
              fields={FieldsQualities(
                optionsProducts,
                optionsWafers,
                productGroup,
                handleChange,
                products,
                edit
              )}
              spacing={2}
            />
          </div>
        )
      case 2:
        return (
          <Files
            data={optionsProducts}
            id={optionsProducts.id}
            edit={edit}
            img={optionsProducts.fotos}
            setImg={setImg}
            changeRender={changeRender}
          />
        )
      case 3:
        return <ComplexDialogHistory history={optionsProducts.historial} />
      default:
        break
    }
  }

  async function handleSubmit() {
    setLoading(true)

    const body = sanitizeBodyForUpdate(optionsProducts)
    const initialBody = sanitizeBodyForUpdate(initialProductRef.current)

    if (JSON.stringify(body) === JSON.stringify(initialBody)) {
      createDismissableSnackbar('No hay cambios para guardar', {
        variant: 'info',
      })
      handleCloseDialog()
      setLoading(false)
      return
    }

    // Check for duplicate orden_colocado
    if (body.orden_colocado !== null && body.orden_colocado !== '') {
      const duplicateProduct = products.find(
        (product) =>
          product.id !== optionsProducts.id &&
          product.orden_colocado !== null &&
          product.orden_colocado !== '' &&
          parseInt(product.orden_colocado) === parseInt(body.orden_colocado)
      )

      if (duplicateProduct) {
        createDismissableSnackbar('El orden colocado ingresado ya existe en otro producto', {
          variant: 'error',
        })
        setLoading(false)
        return
      }
    }

    await interfaces.configInterface
      .updateProduct(optionsProducts.id, body)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        changeRender()
        handleCloseDialog()
        setLoading(false)
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data.data, {
          variant: 'error',
        })
        handleCloseDialog()
        setLoading(false)
      })
  }

  return (
    <ComplexDialog
      open={open}
      onClose={handleCloseDialog}
      tabs={horizontalTabs}
      title={optionsProducts.producto}
      subtitle={
        <div>
          {`ID ${optionsProducts.id} ${
            optionsProducts.fecha_creacion
              ? ` - Creado el ${optionsProducts.fecha_creacion} por ${optionsProducts.usuario}`
              : ''
          }`}
        </div>
      }
      children={renderTabs}
      actions={
        <ComplexDialogActions
          onClose={handleCloseDialog}
          handleSubmit={handleSubmit}
          // canEdit={optionsProducts.canEdit}
          data={sanitizeBodyForUpdate(optionsProducts)}
          editMode={true}
          // leftButton={{
          //   icon: <ExitToApp fontSize="small" />,
          //   title: "Eliminar",
          //   variant: "contained",
          //   disabled:  false ,
          //   style: {background: "rgb(244, 67, 54)", color: "#fff" },
          //   onClick: () => {
          //     setOpen()
          //   },
          // }}
        />
      }
    />
  )
}

export default DialogEdit
